/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} IncodeInputs */

const en_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

const fr_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

const de_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

const it_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incodificare`)
};

const ru_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроенный код`)
};

const es_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incodificar`)
};

const zh_cn2_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

const ja_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インコード`)
};

const hi_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोड में`)
};

const pt_pt2_incode = /** @type {(inputs: IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode`)
};

/**
* | output |
* | --- |
* | "Incode" |
*
* @param {IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const incode = /** @type {((inputs?: IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_incode(inputs)
	if (locale === "de") return de_incode(inputs)
	if (locale === "it") return it_incode(inputs)
	if (locale === "ru") return ru_incode(inputs)
	if (locale === "es") return es_incode(inputs)
	if (locale === "zh-CN") return zh_cn2_incode(inputs)
	if (locale === "ja") return ja_incode(inputs)
	if (locale === "hi") return hi_incode(inputs)
	if (locale === "pt-PT") return pt_pt2_incode(inputs)
	return en_incode(inputs)
});